import React, { useEffect } from 'react';

const Download: React.FC = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    
    // Detect iOS devices
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    
    // Detect Android devices
    const isAndroid = /android/i.test(userAgent);
    
    // Redirect based on device
    if (isIOS) {
      window.location.href = 'https://apps.apple.com/ke/app/mindrush/id6757676022';
    } else if (isAndroid) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.dvtechventures.mindrush';
    } else {
      // Default to Android/Google Play for desktop or unknown devices
      window.location.href = 'https://play.google.com/store/apps/details?id=com.dvtechventures.mindrush';
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#1a1a1a]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p className="text-white text-lg">Redirecting to app store...</p>
      </div>
    </div>
  );
};

export default Download;

